import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ErmDevOpsApiClientService,
  CreateDevOpsActionDialogData} from 'erm-sdk';
import { CreateDevopsActionBaseComponent } from '../create-devops-action-base.component';
import { CreateAccountComponent } from '../../create-account/create-account.component';

@Component({
  standalone: false,
  selector: 'app-create-devops-action-dialog',
  templateUrl: './create-devops-action-dialog.component.html',
  styleUrls: ['./create-devops-action-dialog.component.scss']
})
export class CreateDevopsActionDialogComponent extends CreateDevopsActionBaseComponent {

  constructor(ermDevOpsApiClient: ErmDevOpsApiClientService,
    @Inject(MAT_DIALOG_DATA) public createDevOpsActionDialogData: CreateDevOpsActionDialogData,
    public dialogRef: MatDialogRef<CreateAccountComponent>) {
    super(ermDevOpsApiClient);
    
    // initialize dialog data
    this.cloudCutomers = createDevOpsActionDialogData.cloudCutomers;
    this.cloudAccounts = createDevOpsActionDialogData.cloudAccounts;
    this.cloudEnvironments = createDevOpsActionDialogData.cloudEnvironments;
    this.supportedRegions = createDevOpsActionDialogData.supportedRegions;

    // pre-fill dialog
    this.selectedDevOpsActionAndParameter = createDevOpsActionDialogData.selectedDevOpsActionAndParameter;
    this.createDevOpsActionRequest.customerId = createDevOpsActionDialogData.selectedCutomerId;
    this.createDevOpsActionRequest.accountId = createDevOpsActionDialogData.selectedAccountId;
    this.createDevOpsActionRequest.environmentId = createDevOpsActionDialogData.selectedEnvironmentId;
    this.createDevOpsActionRequest.region = createDevOpsActionDialogData.selectedRegion;
  }

  close(): void {
    this.dialogRef.close({ data: this.createDevOpsActionResponse });
  }
}
